import React from 'react';
import { Section, Container } from '../../common/UI';
import HeroContent from './HeroContent';
import HeroAvatar from './HeroAvatar';
import ScrollIndicator from './ScrollIndicator';

const Hero = () => {
  return (
    <Section 
      id="home" 
      background="gradient" 
      padding="none"
      className="min-h-screen flex items-center relative overflow-hidden"
    >
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-4 h-4 bg-blue-400/20 rounded-full animate-bounce"></div>
        <div className="absolute top-40 right-20 w-6 h-6 bg-purple-400/20 rounded-full animate-bounce" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-40 left-1/4 w-3 h-3 bg-green-400/20 rounded-full animate-bounce" style={{ animationDelay: '2s' }}></div>
        <div className="absolute top-1/3 right-1/3 w-5 h-5 bg-yellow-400/20 rounded-full animate-bounce" style={{ animationDelay: '0.5s' }}></div>
      </div>

      <Container className="relative z-10">
        <div className="flex flex-col lg:flex-row gap-8 items-center justify-between min-h-screen py-20">
          <div className="lg:w-1/2 lg:flex-shrink-0">
            <HeroContent />
          </div>
          <div className="lg:w-1/2 lg:flex-shrink-0 flex justify-center lg:justify-end">
            <HeroAvatar />
          </div>
        </div>
      </Container>

      <ScrollIndicator />
    </Section>
  );
};

export default Hero;
